import { isProdBEnv } from '@/utils/isProdBEnv';
import prodBLoginBg from '@/assets/brand/prod-b/login-bg.png';

/** 正式 A / 测试沿用现有 URL，不改动 default 目录 */
const DEFAULT_LOGIN_BG =
  'https://mdn.alipayobjects.com/huamei_gcee1x/afts/img/A*y0ZTS6WLwvgAAAAAAAAAAAAADml6AQ/fmt.webp';
const DEFAULT_LOGO =
  'https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg';

const DEFAULT_LAYOUT_BG = [
  {
    src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
    left: 85,
    bottom: 100,
    height: '303px',
  },
  {
    src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
    bottom: -68,
    right: -45,
    height: '303px',
  },
  {
    src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
    bottom: 0,
    left: 0,
    width: '331px',
  },
] as const;

function pick<T>(defaultVal: T, prodBVal?: T): T {
  return isProdBEnv() && prodBVal !== undefined ? prodBVal : defaultVal;
}

/**
 * 后台品牌静态资源（正式 B 覆盖 prod-b 目录；A/测试走 default 常量）。
 * logo 待设计：暂与 A 相同，后续替换 prod-b/logo.* 并在此 pick。
 */
export const brandAssets = {
  /** 侧栏 / 登录页 logo */
  logo: pick(DEFAULT_LOGO),
  /** 登录页全屏背景 */
  loginBackgroundImageUrl: pick(DEFAULT_LOGIN_BG, prodBLoginBg),
  /** 登录页背景视频（正式 B 用静态图，不播视频） */
  loginBackgroundVideoUrl: pick(
    'https://gw.alipayobjects.com/v/huamei_gcee1x/afts/video/jXRBRK_VAwoAAAAAAAAAAAAAK4eUAQBr',
    '',
  ),
  /** 布局装饰图（正式 B 暂空，避免与粉系背景冲突） */
  layoutBackgroundImages: isProdBEnv()
    ? []
    : DEFAULT_LAYOUT_BG.map((item) => ({ ...item })),
};
